/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class ValidationGroupsService {

    /**
     * Export validation groups
     * Returns the account's validation groups with their questions and the workflow and opening stages each one validates. A stage is named by its workflow's external id, title, position and parent stage title.
     * @param xAccessToken
     * @returns any OK
     * @throws ApiError
     */
    public static getInternalApiValidationGroupsExport(
        xAccessToken: string,
    ): CancelablePromise<{
        validation_groups?: Array<{
            title?: string;
            data_fields?: Array<any>;
            stage_bindings?: Array<any>;
            opening_bindings?: Array<any>;
        }>;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/internal_api/validation_groups/export',
            headers: {
                'X-ACCESS-TOKEN': xAccessToken,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }

    /**
     * Import a validation group
     * Creates the validation group with its questions and logic jumps, then binds it to the named stages. A group the account already holds by title keeps its questions, and gets the exported ones only when it has none. A stage that already has a group, or an opening stage with an override, is left as it is. A stage that cannot be found is returned in unresolved.
     * @param xAccessToken
     * @param requestBody
     * @returns any OK
     * @throws ApiError
     */
    public static postInternalApiValidationGroupsImport(
        xAccessToken: string,
        requestBody: any,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/internal_api/validation_groups/import',
            headers: {
                'X-ACCESS-TOKEN': xAccessToken,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
            },
        });
    }

}